export const SIGN_IN = "SIGN_IN";
export const SIGN_OUT = "SIGN_OUT";
export const SET_SELECTED_COURSE_ID = "SET_SELECTED_COURSE_ID";
export const CLEAR_SELECTED_COURSE_ID = "CLEAR_SELECTED_COURSE_ID";
export const SET_ACTIVE_INDEX = "SET_ACTIVE_INDEX";
export const SET_COURSES = "SET_COURSES";
export const SET_FILTERED_COURSES = "SET_FILTERED_COURSES";
export const SET_LOADING = "SET_LOADING";
export const SET_ERROR = "SET_ERROR";
export const SET_SEARCH_QUERY = "SET_SEARCH_QUERY";
export const SET_SEARCH_FIELD = "SET_SEARCH_FIELD";
